import { useEffect, useState } from "react";
import AgencyShell, { CaseTable } from "@/components/agency/AgencyShell";
import { ReadinessBadge } from "@/components/StatusBadge";
import api from "@/lib/api";

export function AgencyDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/agency/dashboard").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return <AgencyShell title="Dashboard"><div className="h-40 animate-pulse rounded-md bg-white" /></AgencyShell>;

  const stats = [
    ["Total cases", d.total_cases],
    ["Clients", d.total_clients],
    ["Needs attention", d.needs_attention.length, "warn"],
    ["In review", d.review_queue.length],
  ];

  return (
    <AgencyShell title={d.organization?.name || "Dashboard"}>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map(([label, value, tone]) => (
          <div key={label} className="rounded-md border border-hborder bg-white p-5" data-testid={`agency-stat-${label.toLowerCase().split(" ")[0]}`}>
            <p className="text-xs uppercase tracking-wider text-muted">{label}</p>
            <p className={`mt-1 text-3xl font-semibold ${tone === "warn" ? "text-coral" : "text-heading"}`}>{value}</p>
          </div>
        ))}
      </div>

      <div className="mt-8">
        <h2 className="mb-3 font-serif text-xl text-heading">Clients needing attention</h2>
        <CaseTable cases={d.needs_attention} emptyLabel="No cases need attention right now." />
      </div>
      <div className="mt-8 grid gap-6 lg:grid-cols-2">
        <div>
          <h2 className="mb-3 font-serif text-xl text-heading">Waiting on applicant</h2>
          <CaseTable cases={d.waiting_on_applicant} emptyLabel="Nothing waiting on applicants." />
        </div>
        <div>
          <h2 className="mb-3 font-serif text-xl text-heading">In review</h2>
          <CaseTable cases={d.review_queue} emptyLabel="No cases in review." />
        </div>
      </div>
    </AgencyShell>
  );
}

export function AgencyPipeline() {
  const [cases, setCases] = useState(null);
  useEffect(() => { api.get("/agency/pipeline").then((r) => setCases(r.data)).catch(() => setCases([])); }, []);
  return (
    <AgencyShell title="Case pipeline">
      {cases === null ? <div className="h-40 animate-pulse rounded-md bg-white" /> : <CaseTable cases={cases} emptyLabel="No cases yet." />}
    </AgencyShell>
  );
}

export function AgencyClients() {
  const [clients, setClients] = useState(null);
  useEffect(() => { api.get("/agency/clients").then((r) => setClients(r.data)).catch(() => setClients([])); }, []);
  return (
    <AgencyShell title="Client directory">
      {clients === null ? <div className="h-40 animate-pulse rounded-md bg-white" /> : clients.length === 0 ? (
        <p className="rounded-md border border-dashed border-hborder bg-white p-8 text-center text-sm text-muted">No clients yet.</p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {clients.map((c) => (
            <div key={c.id} className="rounded-md border border-hborder bg-white p-5" data-testid={`client-${c.id}`}>
              <p className="font-semibold text-heading">{c.full_name}</p>
              <p className="mt-0.5 text-sm text-muted">{c.nationality || "Not provided"}</p>
              <p className="mt-3 text-xs text-muted">{c.cases} case(s)</p>
            </div>
          ))}
        </div>
      )}
    </AgencyShell>
  );
}

export function AgencyReviews() {
  const [cases, setCases] = useState(null);
  useEffect(() => { api.get("/agency/pipeline").then((r) => setCases(r.data.filter((c) => ["requested", "in_review"].includes(c.review_state)))).catch(() => setCases([])); }, []);
  return (
    <AgencyShell title="Review queue">
      {cases === null ? <div className="h-40 animate-pulse rounded-md bg-white" /> : <CaseTable cases={cases} emptyLabel="No cases are awaiting review." />}
    </AgencyShell>
  );
}
